import { impersonate } from '@/services/ImpersonateService';
import { useNavigate } from 'react-router';
import { useApolloClient } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

export const ImpersonateButton: FC<{
  userId: string;
}> = ({ userId }) => {
  const navigate = useNavigate();
  const apolloClient = useApolloClient();
  const handleImpersonate = async (userId: string) => {
    try {
      await impersonate(userId);
      navigate('/');
      await apolloClient.resetStore();
    } catch (error) {
      console.error('Impersonation failed', error);
      return false;
    }
  };
  const { t } = useTranslation();

  return (
    <button
      onClick={() => {
        void handleImpersonate(userId);
      }}
    >
      {t('admin:users.impersonateUser')}
    </button>
  );
};
